export const en = {
  dashboard: 'Dashboard',
  location: 'Location',
  photos: 'Photos',
  history: 'History',
  settings: 'Settings',
  connected: 'Connected',
  connecting: 'Connecting',
  disconnected: 'Disconnected',
  error: 'Error',
  reconnect: 'Reconnect',
  photoData: 'Photo Data',
  audioData: 'Audio Data',
  gpsData: 'GPS Data',
  realtimeData: 'Realtime Data',
  waitingForData: 'Waiting for data...',
  gpsDataList: 'GPS Data List',
  waitingForGps: 'Waiting for GPS data...',
  diaryHistory: 'Diary History',
  underDevelopment: 'Feature is under development'
};